import * as Sentry from '@sentry/nextjs';

type SentryData = {
    name: string;
    transactionName: string;
    extra?: Record<string, any>;
    error: Error;
};

export const logSentry = ({name, transactionName, error, extra}: SentryData) => {
    Sentry.withScope(scope => {
        scope.setTag('name', name);
        scope.setTransactionName(transactionName);
        if (extra) {
            scope.setExtras(extra);
        }
        Sentry.captureException(error);
    });
};
